export enum WorkplaceQueryKeys {
  GetOldScheduler = 'UserOldScheduler',
  GetWorkplaces = 'UserGetWorkplaces',
  GetMyWorkplaces = 'UserGetMyWorkplaces',
  GetFavoritesWorkplaces = 'UserGetFavoritesWorkplaces',
}
